import { jsx as d } from "react/jsx-runtime";
import * as r from "react";
import { c as l } from "./index-DLeNytVF.js";
import { c as L } from "./index-UFb2E87s.js";
import { u as k } from "./index-DYfkNB0n.js";
import { u as F } from "./index-DLcqcWxM.js";
import { c as T, C as M, R as I, A as U, a as $ } from "./index-Duz4GUys.js";
import { P as W } from "./index-L6dgm95g.js";
import { P as z } from "./index-BrTLHETv.js";
import { D as B } from "./index-Dz0AUfZX.js";
import { $ as G } from "./utils-CTvPli9r.js";
var x, w = "HoverCard", [H, ue] = L(w, [
  T
]), b = T(), [K, E] = H(w), O = (e) => {
  const {
    __scopeHoverCard: t,
    children: n,
    open: s,
    defaultOpen: a,
    onOpenChange: c,
    openDelay: f = 700,
    closeDelay: v = 300
  } = e, i = b(t), m = r.useRef(0), u = r.useRef(0), C = r.useRef(!1), p = r.useRef(!1), [h, o] = k({
    prop: s,
    defaultProp: a ?? !1,
    onChange: c,
    caller: w
  }), P = r.useCallback(() => {
    clearTimeout(u.current), m.current = window.setTimeout(() => o(!0), f);
  }, [f, o]), R = r.useCallback(() => {
    clearTimeout(m.current), !C.current && !p.current && (u.current = window.setTimeout(() => o(!1), v));
  }, [v, o]), A = r.useCallback(() => o(!1), [o]);
  return r.useEffect(() => () => {
    clearTimeout(m.current), clearTimeout(u.current);
  }, []), /* @__PURE__ */ d(
    K,
    {
      scope: t,
      open: h,
      onOpenChange: o,
      onOpen: P,
      onClose: R,
      onDismiss: A,
      hasSelectionRef: C,
      isPointerDownOnContentRef: p,
      children: /* @__PURE__ */ d(I, { ...i, children: n })
    }
  );
};
O.displayName = w;
var y = "HoverCardTrigger", N = r.forwardRef(
  (e, t) => {
    const { __scopeHoverCard: n, ...s } = e, a = E(y, n), c = b(n);
    return /* @__PURE__ */ d(U, { asChild: !0, ...c, children: /* @__PURE__ */ d(
      z.a,
      {
        "data-state": a.open ? "open" : "closed",
        ...s,
        ref: t,
        onPointerEnter: l(e.onPointerEnter, S(a.onOpen)),
        onPointerLeave: l(e.onPointerLeave, S(a.onClose)),
        onFocus: l(e.onFocus, a.onOpen),
        onBlur: l(e.onBlur, a.onClose),
        onTouchStart: l(e.onTouchStart, (f) => f.preventDefault())
      }
    ) });
  }
);
N.displayName = y;
var j = "HoverCardPortal", [pe, V] = H(j, {
  forceMount: void 0
}), g = "HoverCardContent", D = r.forwardRef(
  (e, t) => {
    const n = V(g, e.__scopeHoverCard), { forceMount: s = n.forceMount, ...a } = e, c = E(g, e.__scopeHoverCard);
    return /* @__PURE__ */ d(W, { present: s || c.open, children: /* @__PURE__ */ d(
      q,
      {
        "data-state": c.open ? "open" : "closed",
        ...a,
        onPointerEnter: l(e.onPointerEnter, S(c.onOpen)),
        onPointerLeave: l(e.onPointerLeave, S(c.onClose)),
        ref: t
      }
    ) });
  }
);
D.displayName = g;
var q = r.forwardRef((e, t) => {
  const {
    __scopeHoverCard: n,
    onEscapeKeyDown: s,
    onPointerDownOutside: a,
    onFocusOutside: c,
    onInteractOutside: f,
    ...v
  } = e, i = E(g, n), m = b(n), u = r.useRef(null), C = F(t, u), [p, h] = r.useState(!1);
  return r.useEffect(() => {
    if (p) {
      const o = document.body;
      return x = o.style.userSelect || o.style.webkitUserSelect, o.style.userSelect = "none", o.style.webkitUserSelect = "none", () => {
        o.style.userSelect = x, o.style.webkitUserSelect = x;
      };
    }
  }, [p]), r.useEffect(() => {
    if (u.current) {
      const o = () => {
        h(!1), i.isPointerDownOnContentRef.current = !1, setTimeout(() => {
          var R;
          ((R = document.getSelection()) == null ? void 0 : R.toString()) !== "" && (i.hasSelectionRef.current = !0);
        });
      };
      return document.addEventListener("pointerup", o), () => {
        document.removeEventListener("pointerup", o), i.hasSelectionRef.current = !1, i.isPointerDownOnContentRef.current = !1;
      };
    }
  }, [i.isPointerDownOnContentRef, i.hasSelectionRef]), r.useEffect(() => {
    u.current && X(u.current).forEach((P) => P.setAttribute("tabindex", "-1"));
  }), /* @__PURE__ */ d(
    B,
    {
      asChild: !0,
      disableOutsidePointerEvents: !1,
      onInteractOutside: f,
      onEscapeKeyDown: s,
      onPointerDownOutside: a,
      onFocusOutside: l(c, (o) => {
        o.preventDefault();
      }),
      onDismiss: i.onDismiss,
      children: /* @__PURE__ */ d(
        M,
        {
          ...m,
          ...v,
          onPointerDown: l(v.onPointerDown, (o) => {
            o.currentTarget.contains(o.target) && h(!0), i.hasSelectionRef.current = !1, i.isPointerDownOnContentRef.current = !0;
          }),
          ref: C,
          style: {
            ...v.style,
            userSelect: p ? "text" : void 0,
            // Safari requires prefix
            WebkitUserSelect: p ? "text" : void 0,
            "--radix-hover-card-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-hover-card-content-available-width": "var(--radix-popper-available-width)",
            "--radix-hover-card-content-available-height": "var(--radix-popper-available-height)",
            "--radix-hover-card-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-hover-card-trigger-height": "var(--radix-popper-anchor-height)"
          }
        }
      )
    }
  );
}), J = "HoverCardArrow", Q = r.forwardRef(
  (e, t) => {
    const { __scopeHoverCard: n, ...s } = e, a = b(n);
    return /* @__PURE__ */ d($, { ...a, ...s, ref: t });
  }
);
Q.displayName = J;
function S(e) {
  return (t) => t.pointerType === "touch" ? void 0 : e();
}
function X(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (s) => s.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
var Y = O, Z = N, _ = D;
const fe = Y, ve = Z, ee = r.forwardRef(({ className: e, align: t = "center", sideOffset: n = 4, ...s }, a) => /* @__PURE__ */ d(
  _,
  {
    ref: a,
    align: t,
    sideOffset: n,
    className: G(
      "z-50 w-64 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-hover-card-content-transform-origin]",
      e
    ),
    ...s
  }
));
ee.displayName = _.displayName;
export {
  fe as HoverCard,
  ee as HoverCardContent,
  ve as HoverCardTrigger
};
//# sourceMappingURL=hover-card.js.map
